"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchRangeHelpers = void 0;
const getSubscriptionWeekFromDate_1 = require("../Util/getSubscriptionWeekFromDate");
class FetchRangeHelpers {
    constructor(dateTimeProvider, dateTimeModifier) {
        this.isDateRangeInSameWeek = (range) => {
            return (this.dateTimeProvider.weekFromDate(range.to) ===
                this.dateTimeProvider.weekFromDate(range.from) &&
                this.dateTimeModifier.yearDiff(range.to, range.from) === 0);
        };
        this.prepareArgsForDifferentWeeksQuery = (periods, dateRange) => {
            const datesBorders = [dateRange.from, dateRange.to];
            const args = [];
            periods.forEach((period) => {
                datesBorders.forEach((border) => {
                    if (this.dateTimeModifier.dateInDateRange(period.startDate, period.endDate, border)) {
                        args.push({
                            periodId: parseInt(period.periodId),
                            week: (0, getSubscriptionWeekFromDate_1.getWeekNumberFromDateRangeByDate)(border, period),
                        });
                    }
                });
            });
            return args;
        };
        this.filterDateByDateRange = (days, dateRange) => {
            return days
                .filter((day) => {
                return this.dateTimeModifier.dateIsSameOrAfter(day.date, dateRange.from);
            })
                .filter((day) => {
                return this.dateTimeModifier.dateIsSameOrAfter(dateRange.to, day.date);
            });
        };
        this.dateTimeProvider = dateTimeProvider;
        this.dateTimeModifier = dateTimeModifier;
    }
}
exports.FetchRangeHelpers = FetchRangeHelpers;
//# sourceMappingURL=FetchRangeHelpers.js.map